// extracted by mini-css-extract-plugin
module.exports = {"iconTooltip":"IconTooltip_iconTooltip__1tsBn","tooltip-effect":"IconTooltip_tooltip-effect__tfR6F"};